import { Component, EventEmitter, inject, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { UiClinngDoubleSelectFormFieldComponent } from '@core/components/ui-clinng-double-select-form-field/ui-clinng-double-select-form-field.component';
import { UiClinngFormFieldComponent } from '@core/components/ui-clinng-form-field/ui-clinng-form-field.component';
import { UiClinngSelectFormFieldComponent } from '@core/components/ui-clinng-select-form-field/ui-clinng-select-form-field.component';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import type { ICustomSelectModel } from '@core/models/custom-select.interface';
import { ResponsiveService } from '@core/services/responsive.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'form-pse',
  standalone: true,
  imports: [UiClinngFormFieldComponent,
    UiClinngSelectFormFieldComponent,
    UiClinngDoubleSelectFormFieldComponent],
  templateUrl: './form-pse.component.html',
  styleUrl: './form-pse.component.scss',
})
export class FormPseComponent implements OnChanges, OnDestroy {
  private readonly fb = inject(FormBuilder);
  private readonly responsiveService = inject(ResponsiveService);

  @Input() bankList: ICustomSelectModel[] = [];
  @Input() documentValues: any[] = [];

  @Output() personTypeDocumentsChange = new EventEmitter<'N' | 'J'>();
  formattedDocumentValues: ICustomSelectModel[] = [];
  isResponsive = false;
  private readonly responsiveSub: Subscription = this.responsiveService.esMaxResponsive$.subscribe(
    (value) => (this.isResponsive = value),
  );
  typeValues: ICustomSelectModel[] = [
    { label: 'JURÍDICA', value: 1 },
    { label: 'NATURAL', value: 2 },
  ];
  form = this.fb.group({
    bank: [null, [Validators.required]],
    bankName: [null, [Validators.required]],
    type: [null, [Validators.required]],
    name: [null, [Validators.required]],
    documentType: [null, [Validators.required]],
    documentNumber: [null, [Validators.required, Validators.minLength(6), Validators.maxLength(10)]],
    mail: [null, [Validators.required, Validators.email]],
  });
  maxLength: number = 10;
  minLength: number = 6;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['documentValues']) {
      if (!changes['documentValues'].firstChange && this.form) {
        this.DocumentTypeControl.setValue(null);
        this.DocumentNumberControl.setValue(null);
        this.DocumentNumberControl.markAsUntouched();
      }
      this.formatDocuments();
    }

  }

  formatDocuments() {
    this.formattedDocumentValues = (this.documentValues ?? []).map((document) => {
      return {
        label: document.codeDocument,
        value: document.codeDocument
      }
    })
  }

  get BankControl(): FormControl {
    return this.form.get('bank') as FormControl;
  }

  get TypeControl(): FormControl {
    return this.form.get('type') as FormControl;
  }

  get NameControl(): FormControl {
    return this.form.get('name') as FormControl;
  }
  get DocumentTypeControl(): FormControl {
    return this.form.get('documentType') as FormControl;
  }
  get DocumentNumberControl(): FormControl {
    return this.form.get('documentNumber') as FormControl;
  }
  get MailControl(): FormControl {
    return this.form.get('mail') as FormControl;
  }


  errorMessageBank(): string {
    const control = this.BankControl;
    if (control.hasError('required')) {
      return 'El campo es requerido';
    }
    return '';
  }

  errorMessageType(): string {
    const control = this.TypeControl;
    if (control.hasError('required')) {
      return 'El campo es requerido';
    }
    return '';
  }

  errorMessageName(): string {
    const control = this.NameControl;
    if (control.hasError('required')) {
      return 'El campo es requerido';
    }
    return '';
  }


  errorMessageTypeAndDocumentNumber(): string {
    const DocumentNumberControl = this.DocumentNumberControl;
    if (DocumentNumberControl.hasError('required')) {
      return 'El campo es requerido';
    } else if (DocumentNumberControl.hasError('minlength') || DocumentNumberControl.hasError('maxlength')) {
      return `El campo debe tener entre ${this.minLength} y ${this.maxLength} dígitos`;
    }
    const DocumentTypeControl = this.DocumentTypeControl;
    if (DocumentTypeControl.hasError('required')) {
      return 'El campo es requerido';
    }
    return '';
  }

  errorMessageMail(): string {
    const control = this.MailControl;
    if (control.hasError('required')) {
      return 'El campo es requerido';
    } else if (control.hasError('email')) {
      return 'El correo no es válido';
    }
    return '';
  }


  onChangePhoneNumber($event: string): void {

  }

  onChangeDocumentTypeEvent(event: any): void {
    let document = this.documentValues.find((document) => document.codeDocument === event);

    if (document) {
      this.maxLength = document.lenghtMax;
      this.minLength = document.lenghtInit;

      this.DocumentNumberControl.setValidators([
        Validators.required,
        Validators.minLength(this.minLength),
        Validators.maxLength(this.maxLength)
      ]);

      this.DocumentNumberControl.updateValueAndValidity();
    }
  }

  onBankChange(event: any): void {
    let bank = this.bankList.find((bank) => bank.value === event.value);
    (this.form.get('bankName') as FormControl<string | null>).setValue(bank?.label ?? null);
  }

  /**
   * El <select> actualiza el FormControl en el mismo tick que (change); leemos en el siguiente
   * para asegurar el valor (string "1"|"2" o number).
   */
  onPersonTypeChange(): void {
    setTimeout(() => {
      if (!this.form) return;
      const raw = this.TypeControl.value;
      if (raw === null || raw === undefined || raw === '') return;
      const isJuridica = Number(raw) === 1;
      this.personTypeDocumentsChange.emit(isJuridica ? 'J' : 'N');
    }, 0);
  }

  nameChange(event: any): void {
    this.NameControl.setValue(event.toUpperCase());
  }

  ngOnDestroy(): void {
    this.responsiveSub.unsubscribe();
  }

}
